import BottomSheet from "components/common/BottomSheet";
import "./within3DaysNotification.scss";

const DEFAULT_ASSOCIATIONS = "PADI / AIDA";

const Day3CertificationNotification = ({
    isOpen,
    onClose,
    onContinue,
    certifications = [],
}) => {
    const associations =
        certifications.length > 0
            ? certifications.map((c) => c.name).join(" / ")
            : DEFAULT_ASSOCIATIONS;

    return (
        <BottomSheet
            isOpen={isOpen}
            onClose={onClose}
            title="꼭 확인해주세요."
            className="within-3-days-notification"
        >
            <div className="within-3-days-notification-content">
                <p>
                    이 수업은 <strong>{associations} 자격증</strong> 발급이 가능한 수업입니다.
                </p>
                <p>
                    선택하신 협회 자격증이 맞는지 다시 한번 확인하시고 수업
                    신청 부탁드립니다.
                </p>
                <p>또한 DAY3 수업 전 <strong>이러닝 수업이 완료</strong>되어야 합니다.</p>
                <button
                    className="btn btn-purple500 btn-full btn-giant"
                    onClick={onContinue}
                >
                    확인했어요
                </button>
            </div>
        </BottomSheet>
    );
};

export default Day3CertificationNotification;
